import React from 'react';
import { Icon } from './Icon.js';
export const IconGridDotsFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("circle", { cx: "9", cy: "3", r: "1", fill: "currentColor" }),
        React.createElement("circle", { cx: "3", cy: "3", r: "1", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "15", cy: "3", r: "1", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "9", cy: "9", r: "1", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "3", cy: "9", r: "1", fill: "currentColor" }),
        React.createElement("circle", { cx: "15", cy: "9", r: "1", fill: "currentColor" }),
        React.createElement("circle", { cx: "9", cy: "15", r: "1", fill: "currentColor" }),
        React.createElement("circle", { cx: "3", cy: "15", r: "1", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "15", cy: "15", r: "1", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconGridDotsFill18.js.map